module.exports = __webpack_public_path__ + "img/m-nex22-back.02c318b3.jpg";